module.exports = __webpack_public_path__ + "static/img/street-background.609ae9d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/street-background.jpg
// module id = ym7o
// module chunks = 1